<template>
  <hidden-menu-button
    :kind="kind"
    :size="size"
    :disabled="disabled"
    :active="active"
    :flip-menu="flipMenu"
    :icon-only="iconOnly"
    class="activity-navigator-button"
    :class="cssClass"
    @click="handleClick"
  >
    <slot />
    <template #overflow-menu>
      <slot name="overflow-menu"></slot>
    </template>
  </hidden-menu-button>
</template>

<script setup lang="ts">
import HiddenMenuButton from "@plugins/common/components/HiddenMenuButton.vue";
import { computed } from "vue";

// Props
interface Props {
  kind?: string;
  size?: string;
  disabled?: boolean;
  iconOnly?: boolean;
  active?: boolean;
  flipMenu?: boolean;
  selected?: boolean;
  showOverflowMenu?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
  kind: "tertiary",
  size: "small",
  disabled: false,
  iconOnly: false,
  active: false,
  flipMenu: true,
  selected: false,
  showOverflowMenu: false,
});

const emit = defineEmits<{
  click: [data: unknown];
}>();

// Computed
const cssClass = computed(() => {
  return {
    selected: props.selected,
  };
});

// Methods
const handleClick = (value) => {
  emit("click", value);
};
</script>

<style lang="scss">
@import "@styles/abstracts/functions";
@import "@styles/themes/sls-theme/tokens/colors";
@import "@styles/themes/sls-theme/tokens/spacing";
@import "@styles/themes/sls-theme/tokens/typo";

.activity-navigator-button {
  &:first-of-type {
    margin-left: 0;
  }

  &:not(:first-child) {
    &::before {
      content: "";
      display: block;
      height: 1px;
      width: 1rem;
      position: absolute;
      top: 50%;
      background-color: $ui-03;
      z-index: -1;

      .editing & {
        background-color: $ui-01;
      }
    }
  }
}
</style>
